import AuthGate from 'components/gates/AuthGate';
import Loading from 'components/common/Loading';
import { isPreviewBuild } from 'components/common/previewEnv';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import authCompany from 'store/selectors/authCompany';
import meStatus from 'store/selectors/meStatus';

const TermsAcceptedGate = ({ component }) => {
  const company = useSelector(authCompany);
  const { isUninitialized, isLoading, isFetching } = useSelector(meStatus);

  if (!company) {
    if (isUninitialized || isLoading || isFetching) {
      return <Loading />;
    }
    if (isPreviewBuild()) {
      return <Navigate replace to="/auth/login" />;
    }
    return null;
  }
  if (company.isAcceptTerms === false) {
    return <Navigate replace to="/welcome" />;
  }

  if (isUninitialized || isLoading) {
    return <Loading />;
  }

  return <AuthGate component={component} />;
};

TermsAcceptedGate.propTypes = {
  component: PropTypes.elementType.isRequired,
};
export default TermsAcceptedGate;
